import { Capacitor } from '@capacitor/core';
import { AppReview } from '@capawesome/capacitor-app-review';
import { useRequiredCurrentUser } from 'FrontRoyalAngular';
import { useErrorLogService } from 'ErrorLogging';
import { hasAdminAccess } from 'Users';
import { Button } from 'Button';
import { SettingRow } from './SettingRow';

// FIXME: Remove after the in-app review prompt is verified on the Play Store internal test track.
// Calls the plugin directly and skips MobileAppRateHelper's eligibility rules and counters.
export function TestAppReviewRow() {
    const currentUser = useRequiredCurrentUser();
    const ErrorLogService = useErrorLogService();

    if (!hasAdminAccess(currentUser) || !Capacitor.isNativePlatform()) return null;

    const requestReview = async () => {
        try {
            await AppReview.requestReview();
        } catch (error) {
            ErrorLogService.notify('Failed to request a test mobile app review', error);
        }
    };

    return (
        <SettingRow
            className="test-app-review-section"
            title="Test app review prompt"
            description="Admin only. The OS can skip the prompt, and TestFlight never shows it."
        >
            <Button variant="bordered-white-light" color="black" height={9} fontWeight="normal" onPress={requestReview}>
                Request review
            </Button>
        </SettingRow>
    );
}
